<template>
	<div>
		<div class="title-container">
			<div class="title">Update Extension</div>
			<div class="buttons">
				<router-link :to="{ name: 'super-account-extensions-page', params: $route.params }" exact class="button"><div class="hover-title">Cancel</div><span class="fa fa-times"></span></router-link>
			</div>
		</div>

		<form ref="form" method="post" @submit.prevent="onSubmit">
			<form-errors :errors="errors"></form-errors>

			<field-errors v-if="submitAttempted" :form="$v.form" field="name"></field-errors>
			<div class="input-container">
				<div class="input-title">Name</div>
				<div class="input-box"><input v-model="form.name" type="text"></div>
			</div>

			<field-errors v-if="submitAttempted" :form="$v.form" field="slug"></field-errors>
			<div class="input-container">
				<div class="input-title">Slug</div>
				<div class="input-box"><input v-model="form.slug" type="text"></div>
			</div>

			<field-errors v-if="submitAttempted" :form="$v.form" field="html"></field-errors>
			<div class="input-container">
				<div class="input-title">HTML</div>
				<div class="input-box"><textarea v-model="form.html"></textarea></div>
			</div>

			<submit-button text="Save Extension" icon="fa-save" :has-errors="hasErrors" :loading="formSaving"></submit-button>
		</form>
	</div>
</template>

<script>

import FormMixin from '@/mixins/FormMixin';
import { required } from 'vuelidate/lib/validators';

export default {

	mixins: [FormMixin],

	name: 'ExtensionsUpdatePage',

	async asyncData({ app, route, store }) {
		const extension = await app.$api.get(`/super/accounts/${ route.params.accountId }/extensions/${ route.params.extensionId }/edit`);

		return {
			form: extension.data.data,
			account: store.state.auth.accountsById[ route.params.accountId ],
		};
	},

	data() {
		return {
			form: {},
		};
	},

	validations: {
		form: {
			name: { required },
			slug: { required },
			html: { required },
		},
	},

	methods: {

		async onSubmit() {
			this.submit(async () => {
				await this.$api.put(`/super/accounts/${ this.account.id }/extensions/${ this.form.id }`, this.form);

				this.$store.dispatch('addToast', 'Extension Updated');
				this.$router.back();
			}, (e) => {
				this.$store.dispatch('errorToast', 'Unable to save extension: ' + e.message);
			});
		},

	},

};

</script>
